export default __webpack_public_path__ + "static/media/img_baseBunny_green.a554cb3c.jpg";